var replacementMap = {
  };

// Extract the first fragment from the URL path
var currentPath = window.location.pathname;
var fragments = currentPath.split("/");

// Since the URL starts with a '/', the first item in fragments will be empty, so the language sign will be the second item.
var langFragment = fragments[1];

// Check if the fragment is in the replacement map and replace it
if(replacementMap.hasOwnProperty(langFragment)) {
    var replacement = replacementMap[langFragment];
    if (replacement.length > 0) {
      fragments[1] = replacement;
    }
    else {
      fragments.splice(1,1);
    }
    var newPath = fragments.join("/");

    // Redirect to the new URL
    window.location.href = window.location.protocol + "//" + window.location.host + newPath + window.location.search + window.location.hash;
}

function getLangSwitcherModal() {
  return document.getElementById('langSwitcher');
}

function getLangSwitcherForm(modal) {
  if (!modal) return null;
  return (
    modal.querySelector('#localization_form_lang_switcher') ||
    modal.querySelector('form[action*="localization"]')
  );
}

function openLangSwitcherModal(e) {
  var modal = getLangSwitcherModal();
  if (!modal) return;
  if (e) {
    e.preventDefault();
  }
  modal.style.display = 'block';
}

function closeLangSwitcherModal() {
  var modal = getLangSwitcherModal();
  if (!modal) return;
  modal.style.display = 'none';
}

function submitLangSwitcherSelection(target) {
  var modal = getLangSwitcherModal();
  var langForm = getLangSwitcherForm(modal);

  if (!langForm) {
    console.warn('[lang-switcher] Formulaire localization introuvable dans #langSwitcher');
    return;
  }

  var countryInput = langForm.querySelector('[name="country_code"]');
  var langInput = langForm.querySelector('[name="language_code"]');

  if (!countryInput || !langInput) {
    console.warn('[lang-switcher] Champs country_code ou language_code introuvables');
    return;
  }

  var country = target.getAttribute('data-country');
  var lang = target.getAttribute('data-lang');

  if (country === 'usa') {
    window.location.href = 'https://us-shop.aperol.com/';
    return;
  }

  if (!country || !lang) {
    console.warn('[lang-switcher] data-country ou data-lang manquant sur', target);
    return;
  }

  langInput.value = lang;
  countryInput.value = country;
  langForm.submit();
}

var langSwitcherModalInitialized = false;

function initLangSwitcherModal() {
  if (langSwitcherModalInitialized) return;

  var modal = getLangSwitcherModal();
  if (!modal) return;

  langSwitcherModalInitialized = true;

  var langSwitchers = document.querySelectorAll('.lang-switcher-cta, [data-lang-switcher-cta]');
  langSwitchers.forEach(function (trigger) {
    trigger.addEventListener('click', openLangSwitcherModal);
  });

  var langSwitcherClose = document.getElementById('langSwitcherClose');
  if (langSwitcherClose) {
    langSwitcherClose.addEventListener('click', closeLangSwitcherModal);
  }

  modal.addEventListener('click', function (e) {
    var target = e.target.closest('.lang-switcher-item');
    if (!target || !modal.contains(target)) return;

    e.preventDefault();
    submitLangSwitcherSelection(target);
  });
}

document.addEventListener('DOMContentLoaded', initLangSwitcherModal);
window.addEventListener('load', initLangSwitcherModal);

function applyWishlistModalLayout() {
  var wrapper = document.querySelector('.frcp-popup-wrapper--open.frcp-popup-wrapper--swall');
  if (!wrapper) return;

  var modal = wrapper.querySelector('.frcp-wishlist-modal');
  if (!modal) return;

  modal.style.removeProperty('top');
  modal.style.removeProperty('left');
  modal.style.removeProperty('right');
  modal.style.removeProperty('bottom');
  modal.style.removeProperty('inset');
  modal.style.setProperty('position', 'relative', 'important');
  modal.style.setProperty('transform', 'none', 'important');
  modal.style.setProperty('margin', '0', 'important');

  [modal.querySelector('.frcp-app'), modal.querySelector('.frcp-main')].forEach(function (el) {
    if (!el) return;
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', '100%', 'important');
  });
}

function haGetWishlistPopupWrapper() {
  return document.querySelector('.frcp-popup-wrapper--open.frcp-popup-wrapper--swall');
}

function haGetWishlistModal() {
  var wrapper = haGetWishlistPopupWrapper();
  return wrapper ? wrapper.querySelector('.frcp-wishlist-modal') : null;
}

function haGetWishlistContentRoot() {
  var modal = haGetWishlistModal();
  if (!modal) return null;
  return (
    modal.querySelector('.frcp-section__content') ||
    modal.querySelector('.frcp-products-container') ||
    modal.querySelector('.frcp-wishlist')
  );
}

var HA_WISHLIST_LOADER_ID = 'ha-wishlist-loader-overlay';

function haWishlistLog() {
  if (window.HA_WISHLIST_DEBUG || localStorage.getItem('haWishlistDebug') === '1') {
    console.log.apply(console, ['[ha-wishlist]'].concat(Array.prototype.slice.call(arguments)));
  }
}

function haPositionWishlistLoader() {
  var overlay = document.getElementById(HA_WISHLIST_LOADER_ID);
  var modal = haGetWishlistModal();
  if (!overlay || !modal) return;

  var rect = modal.getBoundingClientRect();
  overlay.style.top = rect.top + 'px';
  overlay.style.left = rect.left + 'px';
  overlay.style.width = Math.max(rect.width, 1) + 'px';
  overlay.style.height = Math.max(rect.height, 1) + 'px';
}

function haShowWishlistLoader() {
  haHideWishlistLoader();

  var wrapper = haGetWishlistPopupWrapper();
  var modal = haGetWishlistModal();
  if (!wrapper || !modal) return;

  var overlay = document.createElement('div');
  overlay.id = HA_WISHLIST_LOADER_ID;
  overlay.className = 'ha-wishlist-loader-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML = '<div class="ha-wishlist-loader-spinner" role="status" aria-label="Loading"></div>';
  document.body.appendChild(overlay);

  haPositionWishlistLoader();
  overlay._onResize = function () {
    haPositionWishlistLoader();
  };
  window.addEventListener('resize', overlay._onResize);
  window.addEventListener('scroll', overlay._onResize, true);
}

function haHideWishlistLoader() {
  var overlay = document.getElementById(HA_WISHLIST_LOADER_ID);
  if (overlay) {
    if (overlay._onResize) {
      window.removeEventListener('resize', overlay._onResize);
      window.removeEventListener('scroll', overlay._onResize, true);
    }
    overlay.remove();
  }
}

function haWishlistProductCount(root) {
  if (!root) return 0;
  return root.querySelectorAll('.frcp-product').length;
}

function haWishlistIsEmpty(root) {
  if (!root) return true;
  return haWishlistProductCount(root) === 0;
}

function haRefreshFrcpWishlistPopup() {
  if (typeof frcp === 'undefined' || !frcp.wishlist) return false;

  var methods = ['refreshWidget', 'reloadWidget', 'refresh', 'reload', 'updateWidget', 'render'];
  for (var i = 0; i < methods.length; i++) {
    var fn = frcp.wishlist[methods[i]];
    if (typeof fn === 'function') {
      try {
        fn.call(frcp.wishlist);
        haWishlistLog('refresh via', methods[i]);
        return true;
      } catch (err) {
        haWishlistLog('refresh error', methods[i], err);
      }
    }
  }

  return false;
}

function haWishlistHasProduct(opts) {
  opts = opts || {};
  var root = haGetWishlistContentRoot();
  if (!root || haWishlistIsEmpty(root)) return false;

  if (typeof opts.initialCount === 'number' && haWishlistProductCount(root) > opts.initialCount) {
    return true;
  }

  var handle = opts.handle;
  if (!handle) return haWishlistProductCount(root) > 0;

  if (root.querySelector('a[href*="/products/' + handle + '"]')) return true;
  if (root.querySelector('a[href*="' + handle + '"]')) return true;

  var cards = root.querySelectorAll('.frcp-product');
  for (var i = 0; i < cards.length; i++) {
    if (cards[i].innerHTML.indexOf(handle) !== -1) return true;
  }

  return false;
}

function haWaitForFrcpWishlistAdded(opts, timeoutMs) {
  return new Promise(function (resolve) {
    timeoutMs = timeoutMs || 5000;
    var settled = false;
    var frcpObserver = null;
    var heartObserver = null;
    var pollTimer = null;
    var timeoutTimer = null;

    function isAdded() {
      if (
        opts.frcpBtn &&
        (opts.frcpBtn.classList.contains('frcp-wishlist-btn--remove') ||
          opts.frcpBtn.classList.contains('frcp-wishlist-btn--added'))
      ) {
        return true;
      }

      return !!(opts.heartBtn && opts.heartBtn.classList.contains('ha-wishlist-active'));
    }

    function cleanup() {
      if (frcpObserver) frcpObserver.disconnect();
      if (heartObserver) heartObserver.disconnect();
      if (pollTimer) clearInterval(pollTimer);
      if (timeoutTimer) clearTimeout(timeoutTimer);
    }

    function done(result) {
      if (settled) return;
      settled = true;
      cleanup();
      haWishlistLog(result ? 'ajout FRCP confirmé' : 'ajout FRCP non confirmé');
      resolve(result);
    }

    function check() {
      if (isAdded()) done(true);
    }

    if (opts.frcpBtn) {
      frcpObserver = new MutationObserver(check);
      frcpObserver.observe(opts.frcpBtn, { attributes: true, attributeFilter: ['class'] });
    }

    if (opts.heartBtn) {
      heartObserver = new MutationObserver(check);
      heartObserver.observe(opts.heartBtn, { attributes: true, attributeFilter: ['class'] });
    }

    pollTimer = setInterval(check, 100);
    timeoutTimer = setTimeout(function () {
      done(isAdded());
    }, timeoutMs);
    check();
  });
}

function haReloadWishlistPopupOnce(onReady) {
  if (typeof frcp === 'undefined' || !frcp.wishlist || typeof frcp.wishlist.toggleWidget !== 'function') {
    if (typeof onReady === 'function') onReady(false);
    return;
  }

  var wasOpen = !!document.querySelector('.frcp-popup-wrapper--open');
  if (!wasOpen) {
    haOpenFrcpWishlistPopup(function () {
      if (typeof onReady === 'function') onReady(true);
    });
    return;
  }

  haWishlistLog('reload popin (fermeture / réouverture)');
  frcp.wishlist.toggleWidget();

  setTimeout(function () {
    frcp.wishlist.toggleWidget();
    setTimeout(applyWishlistModalLayout, 50);
    setTimeout(applyWishlistModalLayout, 300);
    if (typeof onReady === 'function') {
      setTimeout(function () {
        onReady(true);
      }, 250);
    }
  }, 350);
}

function haWaitForWishlistProduct(opts) {
  return new Promise(function (resolve) {
    var timeoutMs = opts.timeout || 6000;
    var settled = false;
    var observer = null;
    var pollTimer = null;
    var timeoutTimer = null;
    var observedRoot = null;

    function cleanup() {
      if (observer) observer.disconnect();
      if (pollTimer) clearInterval(pollTimer);
      if (timeoutTimer) clearTimeout(timeoutTimer);
    }

    function done(found) {
      if (settled) return;
      settled = true;
      cleanup();
      haWishlistLog(found ? 'produit détecté' : 'timeout', opts);
      resolve(found);
    }

    function check() {
      haPositionWishlistLoader();

      if (haWishlistHasProduct(opts)) {
        done(true);
        return;
      }

      bindObserver();
    }

    function bindObserver() {
      var root = haGetWishlistContentRoot();
      if (!root || root === observedRoot) return;

      if (observer) observer.disconnect();
      observedRoot = root;
      observer = new MutationObserver(check);
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      haWishlistLog('observer attaché sur contenu wishlist');
    }

    timeoutTimer = setTimeout(function () {
      done(false);
    }, timeoutMs);

    pollTimer = setInterval(check, 200);
    check();
  });
}

function haOpenFrcpWishlistPopup(onReady) {
  if (document.querySelector('.frcp-popup-wrapper--open')) {
    if (typeof onReady === 'function') onReady();
    return;
  }

  function tryOpen() {
    if (typeof frcp !== 'undefined' && frcp.wishlist && typeof frcp.wishlist.toggleWidget === 'function') {
      frcp.wishlist.toggleWidget();
      setTimeout(applyWishlistModalLayout, 50);
      setTimeout(applyWishlistModalLayout, 300);
      if (typeof onReady === 'function') {
        setTimeout(onReady, 120);
      }
      return true;
    }
    return false;
  }

  if (!tryOpen()) {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (tryOpen() || attempts > 20) clearInterval(timer);
    }, 100);
  }
}

window.haOpenFrcpWishlist = function () {
  haOpenFrcpWishlistPopup();
};

window.haHandleWishlistAdd = function (options) {
  options = options || {};
  var heartBtn = options.heartBtn;
  var frcpBtn = options.frcpBtn;

  if (
    frcpBtn &&
    (frcpBtn.classList.contains('frcp-wishlist-btn--remove') ||
      frcpBtn.classList.contains('frcp-wishlist-btn--added'))
  ) {
    haWishlistLog('abort add: produit déjà en wishlist');
    return;
  }

  haWishlistLog('add start', options.handle);

  if (heartBtn) heartBtn.classList.add('ha-wishlist-btn--loading');

  function finish() {
    if (heartBtn) heartBtn.classList.remove('ha-wishlist-btn--loading');
    haHideWishlistLoader();
  }

  function waitForProductInPopup(reloadAttempted) {
    options.initialCount = haWishlistProductCount(haGetWishlistContentRoot());
    options.timeout = reloadAttempted ? 8000 : 5000;

    haWaitForWishlistProduct(options).then(function (found) {
      if (found) {
        finish();
        return;
      }

      if (!reloadAttempted) {
        haReloadWishlistPopupOnce(function () {
          haShowWishlistLoader();
          setTimeout(function () {
            haRefreshFrcpWishlistPopup();
            waitForProductInPopup(true);
          }, 200);
        });
        return;
      }

      finish();
    });
  }

  function openPopupAndWaitForProduct() {
    haOpenFrcpWishlistPopup(function () {
      haShowWishlistLoader();
      setTimeout(function () {
        haRefreshFrcpWishlistPopup();
        setTimeout(haRefreshFrcpWishlistPopup, 400);
        waitForProductInPopup(false);
      }, 200);
    });
  }

  if (frcpBtn) {
    frcpBtn.click();
    haWishlistLog('clic FRCP déclenché (avant ouverture popin)');
  }

  haWaitForFrcpWishlistAdded(options, 5000).then(function () {
    setTimeout(openPopupAndWaitForProduct, 150);
  });
};

function setupWishlistModalObserver() {
  var observer = new MutationObserver(function () {
    applyWishlistModalLayout();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  applyWishlistModalLayout();
}

document.addEventListener('DOMContentLoaded', setupWishlistModalObserver);
window.addEventListener('load', setupWishlistModalObserver);

  // Wishlist functionality - Code du support FRCP
  function setupWishlistTrigger() {
    var wishlistTrigger = document.getElementById('wishlist-trigger');
    
    if (wishlistTrigger) {
      wishlistTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Function to check if frcp is available and retry if not
        function tryToggleWishlist() {
          if (typeof frcp !== 'undefined' && frcp.wishlist && frcp.wishlist.toggleWidget) {
            frcp.wishlist.toggleWidget();
            setTimeout(applyWishlistModalLayout, 50);
            setTimeout(applyWishlistModalLayout, 300);
          } else {
            // Retry after 100ms if frcp is not ready
            setTimeout(tryToggleWishlist, 100);
          }
        }
        
        tryToggleWishlist();
      });
      return true;
    } else {
      return false;
    }
  }
  
  // Try to setup immediately
  if (!setupWishlistTrigger()) {
    // If not found, retry after a short delay
    setTimeout(function() {
      if (!setupWishlistTrigger()) {
        // If still not found, retry again
        setTimeout(setupWishlistTrigger, 500);
      }
    }, 100);
  }

document.addEventListener("DOMContentLoaded", function () {
    const wrapperSelector = '.frcp-wishlist-link-wrapper';
    const countSelector = '.frcp-wishlist-link-count';

    function updateVisibility(wrapper, countEl) {
      const count = parseInt(countEl.getAttribute('data-count') || '0', 10);
      if (count > 0) {
        wrapper.style.display = 'block';
        requestAnimationFrame(() => {
          wrapper.classList.add('visible');
        });
      } else {
        wrapper.classList.remove('visible');
        setTimeout(() => {
          wrapper.style.display = 'none';
        }, 400);
      }
    }

    function waitForWishlistModule() {
      const observer = new MutationObserver(() => {
        const wrapper = document.querySelector(wrapperSelector);
        const countEl = document.querySelector(countSelector);

        if (wrapper && countEl) {
          updateVisibility(wrapper, countEl);

          const countObserver = new MutationObserver(() => {
            updateVisibility(wrapper, countEl);
          });

          countObserver.observe(countEl, {
            attributes: true,
            attributeFilter: ['data-count']
          });

          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    waitForWishlistModule();
  });
